<p-table [value]="produits" #dt2  [globalFilterFields]="['designation']" >


    
    <ng-template pTemplate="caption"> 
 
 
        <div style="text-align: right">     
            <span *ngIf="dt2.filteredValue"> {{dt2.filteredValue.length}} / </span>{{dt2.totalRecords}} Publicite
            <button type="button"   pButton icon="pi pi-file-excel" iconPos="left"
             label="Exporter" (click)="exportExcel()" style="margin-right: 0.5em;  background-color:  rgb(242, 148, 0)!important;text-align: left"></button>

            <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
            <input type="text" pInputText size="50" placeholder="Designation Publicite" (input)="dt2.filterGlobal($event.target.value, 'contains')" style="width:auto">
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
          
            <th>Entreprise</th>
            <th>Produits</th>
            <th>Prix Unitaire</th>
            <th>Quantité</th>
            <th>Facture</th>
            <th>Stand</th>
            <th>Remarque</th>
     
        </tr>
        
    </ng-template>
    <ng-template pTemplate="body" let-produit>
        <tr [pSelectableRow]="produit">

 
            <td><span *ngIf="produit.idfacture">{{produit.idfacture.client.raisonSocial}}</span>  </td>
            <td>{{produit.designation}}</td>
            <td>{{produit.prixunit}}</td>

            <td>{{produit.quantite}}</td>

            <td>{{produit.idfacture.numeroFiche}}</td>
             
            <td>{{produit.idfacture.client.standList}}  </td>
            <td>{{produit.idfacture.observation}}</td>


            
        </tr>
    </ng-template>
</p-table>